export default "__VITE_ASSET__a4894ebc__"